module.exports = __webpack_public_path__ + "static/card3-73fd6bc6044140829483fc1265448d3c.png";